import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Check } from 'lucide-react';
const bonuses = ['Plantilla profesional CV para yates', 'Checklist antes de aplicar', '50 preguntas reales de entrevistas', 'Guía rápida de inglés para chefs', 'Mapa paso a paso para conseguir tu primer embarque'];
export function Bonuses() {
  return <section className="py-16 bg-background relative overflow-hidden" data-id="element-27">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-28"></div>

      <div className="px-5 relative z-10" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-30">
          <Card className="bg-secondary/40 border-primary/30 relative overflow-visible mt-4" data-id="element-31">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground px-5 py-1.5 rounded-full font-bold text-xs tracking-wider shadow-lg shadow-primary/20 uppercase whitespace-nowrap" data-id="element-32">
              GRATIS SOLO POR HOY
            </div>

            <CardContent className="p-5 pt-10" data-id="element-33">
              <div className="text-center mb-7" data-id="element-34">
                <h2 className="text-2xl font-bold text-white font-heading leading-tight" data-id="element-35">
                  Bonos exclusivos
                  <br data-id="element-36" />
                  incluidos
                </h2>
              </div>

              <div className="space-y-3 mb-8" data-id="element-37">
                {bonuses.map((bono, index) => <motion.div key={index} className="flex items-start gap-3 p-3 rounded-xl bg-background/50 border border-border/50" initial={{
                opacity: 0,
                x: -15
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} data-id="element-38">
                    <div className="mt-0.5 bg-primary/20 p-1 rounded-full text-primary shrink-0" data-id="element-39">
                      <Check className="w-3.5 h-3.5" data-id="element-40" />
                    </div>
                    <p className="text-sm text-white/90 font-medium leading-snug" data-id="element-41">
                      <span className="text-primary mr-1" data-id="element-42">
                        Bono {index + 1}:
                      </span>
                      {bono}
                    </p>
                  </motion.div>)}
              </div>

              <div className="text-center p-5 rounded-2xl bg-background/80 border border-border flex flex-col items-center justify-center" data-id="element-43">
                <p className="text-white/50 text-base mb-1 line-through decoration-red-500/50 decoration-2" data-id="element-44">
                  Valor total: $90.000
                </p>
                <p className="text-2xl font-bold text-primary font-heading" data-id="element-45">
                  Hoy incluidos GRATIS
                </p>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>;
}